<template>
  <div>
    <div class="row">
      <div class="col-sm-12">
        <div class="card">
          <div class="card-body">
            <div class="row">
              <div class="col-sm-6">
                <router-link :to="{name: 'clientDetails', clientId: clientId}">powrót</router-link>
              </div>
              <div class="col-sm-6 text-right">
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-md-6">
        <div class="card">
          <div class="card-header">
            <div>Powiąż</div>
          </div>
          <div class="card-body">
            <form @submit.prevent="findclientToBeMerged()">
              <div class="row">
                <div class="form-group col-md-3">
                  <label>ID klienta</label>
                  <input class="form-control" v-model="clientToBeMergedId" type="text"/>
                </div>
              </div>
              <div class="row">
                <div class="form-group col-md-4">
                  <button type="submit" class="btn btn-primary">Szukaj</button>
                </div>
              </div>
            </form>

          </div>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-sm-6">
        <div class="card" v-if="client">
          <div class="card-header">
            <div>Dane klienta</div>
          </div>
          <div class="card-body">
            <div class="row">
              <div class="col-md-5">Imiona</div>
              <div class="col-md-7">{{ client.firstName }}</div>
            </div>

            <div class="row">
              <div class="col-md-5">Nazwisko</div>
              <div class="col-md-7">{{ client.lastName }}</div>
            </div>

            <div class="row">
              <div class="col-md-5">PESEL</div>
              <div class="col-md-7">{{ client.pesel}}</div>
            </div>

            <div class="row">
              <div class="col-md-5">Ulica</div>
              <div class="col-md-7">{{ client.street}}</div>
            </div>

            <div class="row">
              <div class="col-md-5">Nr domu</div>
              <div class="col-md-7">{{ client.streetNo}}</div>
            </div>

            <div class="row">
              <div class="col-md-5">Nr mieszkania</div>
              <div class="col-md-7">{{ client.flatNo}}</div>
            </div>

            <div class="row">
              <div class="col-md-5">Miasto</div>
              <div class="col-md-7">{{ client.city}}</div>
            </div>

            <div class="row">
              <div class="col-md-5">Kraj</div>
              <div class="col-md-7">{{ client.country}}</div>
            </div>

            <div class="row">
              <div class="col-md-5">Telefon</div>
              <div class="col-md-7">{{ client.phone}}</div>
            </div>

            <div class="row">
              <div class="col-md-5">E-mail</div>
              <div class="col-md-7">{{ client.email}}</div>
            </div>
          </div>
        </div>
      </div>
      <div class="col-sm-6">
        <div class="card" v-if="clientToBeMerged">
          <div class="card-header">
            <div>Dane klienta</div>
          </div>
          <div class="card-body">
            <div class="row">
              <div class="col-md-5">Imiona</div>
              <div class="col-md-7">{{ clientToBeMerged.firstName }}</div>
            </div>

            <div class="row">
              <div class="col-md-5">Nazwisko</div>
              <div class="col-md-7">{{ clientToBeMerged.lastName }}</div>
            </div>

            <div class="row">
              <div class="col-md-5">PESEL</div>
              <div class="col-md-7">{{ clientToBeMerged.pesel}}</div>
            </div>

            <div class="row">
              <div class="col-md-5">Ulica</div>
              <div class="col-md-7">{{ clientToBeMerged.street}}</div>
            </div>

            <div class="row">
              <div class="col-md-5">Nr domu</div>
              <div class="col-md-7">{{ clientToBeMerged.streetNo}}</div>
            </div>

            <div class="row">
              <div class="col-md-5">Nr mieszkania</div>
              <div class="col-md-7">{{ clientToBeMerged.flatNo}}</div>
            </div>

            <div class="row">
              <div class="col-md-5">Miasto</div>
              <div class="col-md-7">{{ clientToBeMerged.city}}</div>
            </div>

            <div class="row">
              <div class="col-md-5">Kraj</div>
              <div class="col-md-7">{{ clientToBeMerged.country}}</div>
            </div>

            <div class="row">
              <div class="col-md-5">Telefon</div>
              <div class="col-md-7">{{ clientToBeMerged.phone}}</div>
            </div>

            <div class="row">
              <div class="col-md-5">E-mail</div>
              <div class="col-md-7">{{ clientToBeMerged.email}}</div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-sm-6">
        <div class="card" v-if="suggestedClient">
          <div class="card-header">
            <div>Dane klienta</div>
          </div>
          <div class="card-body">
            <form @submit.prevent="mergeClients()">
              <div class="row form-group">
                <div class="col-md-5">Imiona</div>
                <div class="col-md-7">
                  <input type="text" class="form-control" v-model="suggestedClient.firstName"/>
                </div>
              </div>

              <div class="row form-group">
                <div class="col-md-5">Nazwisko</div>
                <div class="col-md-7">
                  <input type="text" class="form-control" v-model="suggestedClient.lastName"/>
                </div>
              </div>

              <div class="row form-group">
                <div class="col-md-5">PESEL</div>
                <div class="col-md-7">
                  <input type="text" class="form-control" v-model="suggestedClient.pesel"/>
                </div>
              </div>

              <div class="row form-group">
                <div class="col-md-5">Ulica</div>
                <div class="col-md-7">
                  <input type="text" class="form-control" v-model="suggestedClient.street"/>
                </div>
              </div>

              <div class="row form-group">
                <div class="col-md-5">Nr domu</div>
                <div class="col-md-7">
                  <input type="text" class="form-control" v-model="suggestedClient.streetNo"/>
                </div>
              </div>

              <div class="row form-group">
                <div class="col-md-5">Nr mieszkania</div>
                <div class="col-md-7">
                  <input type="text" class="form-control" v-model="suggestedClient.flatNo"/>
                </div>
              </div>

              <div class="row form-group">
                <div class="col-md-5">Miasto</div>
                <div class="col-md-7">
                  <input type="text" class="form-control" v-model="suggestedClient.city"/>
                </div>
              </div>

              <div class="row form-group">
                <div class="col-md-5">Kraj</div>
                <div class="col-md-7">
                  <input type="text" class="form-control" v-model="suggestedClient.country"/>
                </div>
              </div>

              <div class="row form-group">
                <div class="col-md-5">Telefon</div>
                <div class="col-md-7">
                  <input type="text" class="form-control" v-model="suggestedClient.phone"/>
                </div>
              </div>

              <div class="row form-group">
                <div class="col-md-5">E-mail</div>
                <div class="col-md-7">
                  <input type="text" class="form-control" v-model="suggestedClient.email"/>
                </div>
              </div>
              <button type="submit" class="btn btn-primary">Połącz</button>
            </form>
          </div>
        </div>

      </div>
    </div>
  </div>
</template>

<script>
  import clients from '@Service/clients';
  import moment from 'moment';
  import { router } from '@Router';
  import { toastError } from '../helpers';

  export default {
    data() {
      return {
        /** @type {clientDetailsItem} */
        client: null,
        clientId: '',
        clientToBeMerged: null,
        clientToBeMergedId: '',
        suggestedClient: null,
      };
    },
    methods: {
      getClient: function (clientId) {
        return clients.getClientDetails(clientId)
          .then(response => {
            const { status, data } = response;
            return status === 200 ? data : null;
          });
      },
      mergeClients: function () {
        const data = {
          clientData: this.suggestedClient,
          oldClientId: this.clientToBeMergedId,
        };
        const clientId = this.clientId;
        clients.mergeClient(clientId, data)
          .then(() => {
            router.push({ name: 'clientDetails', params: { clientId } });
          })
          .catch(toastError);
      },
      suggestClient: function () {
        const clientDate = moment(this.client.modificationDate || this.client.creationDate);
        const mergedDate = moment(this.clientToBeMerged.modificationDate || this.clientToBeMerged.creationDate);
        let masterClient;
        let slaveClient;
        if (clientDate.isAfter(mergedDate)) {
          masterClient = this.client;
          slaveClient = this.clientToBeMerged;
        } else {
          masterClient = this.clientToBeMerged;
          slaveClient = this.client;
        }
        this.suggestedClient = {
          firstName: masterClient.firstName || slaveClient.firstName,
          lastName: masterClient.lastName || slaveClient.lastName,
          street: masterClient.street || slaveClient.street,
          streetNo: masterClient.streetNo || slaveClient.streetNo,
          flatNo: masterClient.flatNo || slaveClient.flatNo,
          postalCode: masterClient.postalCode || slaveClient.postalCode,
          city: masterClient.city || slaveClient.city,
          pesel: masterClient.pesel || slaveClient.pesel,
          phone: masterClient.phone || slaveClient.phone,
          country: masterClient.country || slaveClient.country,
          email: masterClient.email || slaveClient.email,
        };
      },
      findclientToBeMerged: function () {
        this.getClient(this.clientId)
          .then(client => {
            this.client = client;
          })
          .then(() => this.getClient(this.clientToBeMergedId))
          .then(client => {
            this.clientToBeMerged = client;
          })
          .then(() => this.suggestClient())
          .catch(toastError);
      }
    },
    mounted: function () {
      this.clientId = this.$route.params.clientId;
    },
  };
</script>

<style scoped>
  .tabs {
    margin-bottom: 1.5rem;
  }
</style>
